// import { TagIcon } from "@heroicons/react/24/outline";
import CustomLoading from "../../../utils/LoadingIndicator/CustomLoading";
import useAdminDashboard from "./useAdminDashboard";

const CategoriesComponent = () => {
  const { categories, isLoading, errors } = useAdminDashboard(); // Assuming useAdminDashboard provides categories
  if (isLoading.categories) {
    return <CustomLoading />;
  }
  if (errors.categories) {
    return (
      <p className="text-xl font-semibold text-red-700">Some Error Occured</p>
    );
  }
  const formatCurrency = (amount) => {
    return new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "EGP",
    }).format(amount);
  };

  const categoryStats = [
    {
      label: "Total Categories",
      value: categories?.totalCategories || 0,
      color: "text-blue-600",
    },
  ];

  const categoryPerformance = categories?.categoryPerformance || [];

  return (
    <div className="p-3 bg-white rounded-md shadow-sm border border-gray-100">
      <h2 className="text-lg font-semibold text-gray-800 mb-2 leading-tight flex items-center">
        {/* <TagIcon className="w-4 h-4 mr-1 text-gray-600" /> */}
        Category Analytics
      </h2>

      {/* Category Stats */}
      <div className="grid grid-cols-1 gap-1 mb-2">
        {categoryStats.map((stat, index) => (
          <div key={index} className="text-center p-2 bg-gray-50 rounded-sm">
            <p
              className={`text-base font-semibold ${stat.color} leading-tight`}
            >
              {stat.value}
            </p>
            <p className="text-xs text-gray-600">{stat.label}</p>
          </div>
        ))}
      </div>

      {/* Category Performance */}
      <div>
        <h3 className="text-sm font-semibold text-gray-800 mb-1 leading-tight flex items-center">
          {/* <Star className="w-4 h-4 mr-1 text-yellow-500" /> */}
          Category Performance
        </h3>
        <div className="space-y-1">
          {categoryPerformance.length > 0 ? (
            categoryPerformance.map((category) => (
              <div
                key={category.categoryId}
                className="flex items-center justify-between p-2 bg-gray-50 rounded-sm hover:bg-gray-100 transition-colors"
              >
                <div className="flex items-center space-x-2">
                  <div className="w-6 h-6 bg-gradient-to-br from-blue-500 to-purple-600 rounded-full flex items-center justify-center text-white font-bold text-xs">
                    {category.categoryName?.charAt(0) || "C"}
                  </div>
                  <div>
                    <p className="font-semibold text-gray-800 text-sm leading-tight">
                      {category.categoryName || "Unknown Category"}
                    </p>
                    <p className="text-xs text-gray-500 truncate max-w-[120px]">
                      {category.categoryId.slice(-6)}
                    </p>
                  </div>
                </div>
                <div className="text-right">
                  <p className="font-semibold text-green-600 text-sm leading-tight">
                    {formatCurrency(category.totalRevenue)}
                  </p>
                  <p className="text-xs text-gray-500">
                    {category.totalSold} sold, {category.productCount} products
                  </p>
                </div>
              </div>
            ))
          ) : (
            <p className="text-gray-500 text-xs">No category data available</p>
          )}
        </div>
      </div>
    </div>
  );
};

export default CategoriesComponent;
